const isEnabled = (): boolean => typeof mixpanel !== 'undefined';

export const getProperty = (property: string) => {
  if (isEnabled() && typeof mixpanel.get_property === 'function') {
    mixpanel.get_property(property);
  }
};
export const resetUser = () => {
  if (isEnabled()) {
    mixpanel.reset();
  }
};
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const register = (properties: Record<string, any>, days?: number) => {
  if (isEnabled()) {
    mixpanel.register(properties, days);
  }
};
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const registerOnce = (properties: Record<string, any>) => {
  if (isEnabled()) {
    mixpanel.register_once(properties);
  }
};
export const unregister = (property: string) => {
  if (isEnabled()) {
    mixpanel.unregister(property);
  }
};
export const track = (
  eventName: string,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  properties: Record<string, any>,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  callback: ((...args: Array<any>) => any) | null | undefined
) => {
  if (isEnabled()) {
    mixpanel.track(eventName, properties, callback);
    return;
  }

  // If mixpanel is disabled, manually invoke callback
  if (callback) callback();
};
// only use for external links, not with react-router
export const trackLinks = (
  el: Element,
  eventName: string,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  properties: Record<string, any>
) => {
  if (isEnabled()) {
    mixpanel.track_links(el, eventName, properties);
  }
};
